import React from 'react';
import { isVendorMode } from '../../../lib/Vendor';
import SecurityDialog from './SecurityDialog';
import UnifiedSecurityDialogContent from './UnifiedSecurityDialogContent';
import { AccessConfirmationData } from './Security';
import {
  ContactSchema,
  UserSchema,
  RoomSecuritySchema,
} from '../../../definitions/schemas';

type PickedRoomSecurityProps = Pick<
  RoomSecuritySchema,
  'invitedContactsOnly' | 'requiresEmail' | 'requiresPasscode' | 'verifyEmail'
>;

interface Props extends PickedRoomSecurityProps {
  contact?: ContactSchema;
  isConsentDeclinedSuppression?: boolean;
  displayConsent?: boolean;
  email?: string;
  hasError: boolean;
  loading: boolean;
  onActivityDataConsentDecision?: (accepted: boolean) => void;
  onSubmit: (data: AccessConfirmationData) => void;
  open: boolean;
  owner?: UserSchema;
  roomType?: string;
  shouldUseUnifiedConsent?: boolean;
}

const SecurityDialogWrapper: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    shouldUseUnifiedConsent: shouldUseUnifiedConsentProp,
    isConsentDeclinedSuppression,
    onActivityDataConsentDecision,
    ...rest
  } = props;

  const isVendor = isVendorMode();
  const shouldUseUnifiedConsentFromHook = isVendor;
  const shouldUseUnifiedConsent =
    shouldUseUnifiedConsentProp ?? shouldUseUnifiedConsentFromHook;

  if (shouldUseUnifiedConsent) {
    return (
      <UnifiedSecurityDialogContent
        {...rest}
        isConsentDeclinedSuppression={isConsentDeclinedSuppression}
        onActivityDataConsentDecision={onActivityDataConsentDecision}
      />
    );
  }

  return <SecurityDialog {...rest} />;
};

export default SecurityDialogWrapper;
